/* eslint-disable */
import { makeRequest } from "app/utils/makeRequest";
import { getSessionStore } from "app/utils/sessionStore";
import { useEffect, useState, memo } from "react";
import FilterGroupContainer from "../FilterGroupContainer";
import { ProposalTypes } from "app/utils/types";
import {
  fundingOptions,
  fundingSDOptions,
  fundingPFOptions,
  projectionBSOptions,
  projectionKPOptions,
  projectionSDOptions,
  projectionPFOptions,
} from "app/utils/utils";
import { Skeleton } from "primereact/skeleton";
import { isEmpty } from "ramda";
import { useIPContext } from "app/pages/InteractiveProposal/InteractiveProposalProvider";
import { useComments } from "../../Comments/CommentContext";

type ValuesType = {
  OUTSIDE_COLLATERAL_REQUIREMENT: boolean;
  [key: string]: boolean;
};

const InsuredFilter = ({
  onShareholdersChange,
  brandingColor,
  label,
  filter,
}: {
  onShareholdersChange: (
    selectedShareholderIds: string[],
    selectedFundingIds: string[],
    brandingColor: string,
  ) => void;
  brandingColor: string;
  label: string;
  filter: any;
}) => {
  const [shareholdersData, setShareholdersData] = useState<any>([]);
  const [selectedShareholders, setSelectedShareholders] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedFunding, setSelectedFunding] = useState<ValuesType>(
    Object.keys(filter ?? {}).reduce((acc: any, key) => {
      const showKeyVal = key === "OUTSIDE_COLLATERAL_REQUIREMENT" ? false : true;
      acc[key] = showKeyVal;
      return acc;
    }, {}),
  );

  const { setIsCurrPageLoading } = useComments();

  const { selectedVersion, summaryData: proposalSummary, setInsuredDisabled } = useIPContext();
  const proposalId = selectedVersion?.id ?? getSessionStore("interactiveProposalID");
  const proposalPlatform = {
    [ProposalTypes.BuySell]: "shareHolderLedgerList",
    [ProposalTypes.KeyPersonInsurance]: "kpishareHolderLedgerList",
    [ProposalTypes.SplitDollar]: "shareHolderLedgerList",
    [ProposalTypes.PremiumFinance]: "interactiveProposalFunding",
  };
  const lableNamesForProposal = {
    [ProposalTypes.BuySell]: "Shareholders",
    [ProposalTypes.KeyPersonInsurance]:
      proposalSummary?.proposalType === ProposalTypes.KeyPersonInsurance
        ? "Key Person"
        : "Shareholders",
    [ProposalTypes.SplitDollar]: "Insured Person",
    [ProposalTypes.PremiumFinance]: "Insured Person",
  };
  const secondFilterOptions = {
    [ProposalTypes.BuySell]:
      label === "Funding" ? fundingOptions(brandingColor) : projectionBSOptions(brandingColor),
    [ProposalTypes.KeyPersonInsurance]:
      label === "Funding" ? fundingOptions(brandingColor) : projectionKPOptions(brandingColor),
    [ProposalTypes.SplitDollar]:
      label === "Funding" ? fundingSDOptions(brandingColor) : projectionSDOptions(brandingColor),
    [ProposalTypes.PremiumFinance]:
      label === "Funding" ? fundingPFOptions(brandingColor) : projectionPFOptions(brandingColor),
  };

  useEffect(() => {
    const selectedShareholdersCount = Object.values(selectedShareholders)?.filter(Boolean)?.length;
    setInsuredDisabled(selectedShareholdersCount !== 1);
  }, [selectedShareholders]);

  useEffect(() => {
    setLoading(true);
    if (proposalSummary?.proposalType === ProposalTypes.PremiumFinance) {
      const insuredDetails = proposalSummary?.insuredDetails?.map((item: any) => {
        const { firstName, lastName } = item?.user?.profile;
        return {
          id: item?.userId,
          name: `${firstName} ${lastName}`,
        };
      });
      setShareholdersData(insuredDetails);
      setSelectedShareholders(
        insuredDetails?.reduce((acc: any, item: any) => {
          acc[item?.id] = true;
          return acc;
        }, {}),
      );
      setLoading(false);
      return;
    } else if (proposalSummary?.proposalType === ProposalTypes.SplitDollar) {
      const insuredDetails =
        proposalSummary?.insuredDetails?.[0] || proposalSummary?.primaryContact;
      setShareholdersData([
        {
          id: "123",
          name: `${insuredDetails?.firstName} ${insuredDetails?.lastName}`,
        },
      ]);
      setSelectedShareholders({
        "123": true,
      });
      setLoading(false);
    } else {
      setIsCurrPageLoading(true);
      if (proposalSummary?.proposalType) {
        makeRequest(
          proposalPlatform[proposalSummary?.proposalType as keyof typeof proposalPlatform],
        )
          .get(`${proposalId}?ownershipPercentage=ALL`, true, false)
          .then((res) => {
            setShareholdersData(
              res?.data?.data?.map((item: any) => ({
                ...item,
                name: `${item?.user?.profile?.firstName} ${item?.user?.profile?.lastName}`,
              })),
            );
            setSelectedShareholders(
              res?.data?.data?.reduce((acc: any, item: any) => {
                acc[item?.id] = true;
                return acc;
              }, {}),
            );
            setLoading(false);
            setIsCurrPageLoading(false, true);
          });
      }
    }
  }, [proposalSummary?.proposalType]);
  useEffect(() => {
    if (!isEmpty(selectedShareholders)) {
      onShareholdersChange(
        Object.keys(selectedShareholders)?.filter((key) => selectedShareholders[key]),
        Object.keys(selectedFunding)?.filter((key) => selectedFunding[key]),
        brandingColor,
      );
    }
  }, [selectedShareholders, selectedFunding, brandingColor]);

  return (
    <>
      {loading ? (
        <div className="flex items-center h-full gap-1 w-[55%] p-2 flex-col">
          <Skeleton className="w-[30%] h-[60px] mt-4" />
          <Skeleton className="w-[30%] h-[60px] mt-4" />
        </div>
      ) : (
        <FilterGroupContainer
          title={
            lableNamesForProposal[
              proposalSummary?.proposalType as keyof typeof lableNamesForProposal
            ]
          }
          options={shareholdersData}
          selectedOptions={selectedShareholders}
          setSelectedOptions={setSelectedShareholders}
          className="w-[55%] !overflow-auto"
          brandingColor={brandingColor}
          hideCheckbox={proposalSummary?.proposalType === ProposalTypes.SplitDollar}
        />
      )}
      <FilterGroupContainer
        title={label}
        options={
          secondFilterOptions[proposalSummary?.proposalType as keyof typeof secondFilterOptions]
        }
        isTooltip={proposalSummary?.proposalType === ProposalTypes.SplitDollar}
        selectedOptions={selectedFunding}
        setSelectedOptions={(clickedKey: any, optionId?: string) => {
          if (optionId === "OUTSIDE_COLLATERAL_REQUIREMENT") {
            const updatedValues = Object.keys(clickedKey).reduce((acc, key) => {
              acc[key as keyof ValuesType] = key === "OUTSIDE_COLLATERAL_REQUIREMENT";
              return acc;
            }, {} as ValuesType);
            setSelectedFunding(updatedValues);
          } else {
            clickedKey.OUTSIDE_COLLATERAL_REQUIREMENT = false;
            setSelectedFunding(clickedKey);
          }
        }}
        className="flex-1 border-l border-gray-300 dark:!border-[#3A3A50] pl-4 !overflow-auto"
        brandingColor={brandingColor}
      />
    </>
  );
};
export default memo(InsuredFilter);
